import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'isDefined',
    pure: true,
    standalone: false,
})
export class IsDefinedPipe implements PipeTransform {
    transform (input: any): boolean {
        return typeof input !== 'undefined';
    }
}
